import { makeStyles } from '@material-ui/core'

export const mappingOptions = [
  { label: 'Not Set', value: '' },
  { label: 'Constant', value: 'constant' },
  { label: 'Direct', value: 'direct' },
  { label: 'Expression', value: 'expression' },
  { label: 'Translation', value: 'translation' }
]

export const sourceOptions = [
  { label: 'Not Set', value: '' },
  { label: 'Constant', value: 'constant' },
  { label: 'Key Datapoint', value: 'kdp' },
  { label: 'Group Membership', value: 'gm' }
]

export const useDialogStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    fontWeight: theme.typography.weights.light,
    '& strong': {
      fontWeight: theme.typography.weights.bold
    }
  },
  group: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    width: '100%',
    '& > *': {
      flex: '1 0 auto'
    }
  },
  textarea: {
    width: '100%',
    marginBottom: '10px',
    resize: 'none',
    height: '300px'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  editorWrapper: {
    border: `1px solid ${theme.palette.gray.main}`,
    marginBottom: theme.layout.margin.thick,
    maxWidth: '100%'
  }
}))
